import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  MessageSquare, 
  BarChart3, 
  Shield, 
  ScrollText, 
  Settings,
  Cpu,
  Activity,
  Radio,
  Brain
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', exact: true },
  { to: '/chat', icon: MessageSquare, label: 'Chat Interface' },
  { to: '/channels', icon: Radio, label: 'Channels' },
  { to: '/training', icon: Brain, label: 'Intent Training' },
  { to: '/analytics', icon: BarChart3, label: 'Analytics' },
  { to: '/audit', icon: ScrollText, label: 'Audit Logs' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export function Sidebar() {
  return (
    <aside className="fixed left-0 top-0 z-40 h-screen w-64 glass border-r border-border/50">
      <div className="flex h-full flex-col">
        {/* Logo */}
        <div className="flex items-center gap-3 px-6 py-5 border-b border-border/50">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/20 glow-primary">
            <Cpu className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h1 className="font-heading font-bold text-lg tracking-tight text-foreground">
              ELLIE
            </h1>
            <p className="text-[10px] font-mono uppercase tracking-wider text-muted-foreground">
              Tiered Inference
            </p>
          </div>
        </div>

        {/* Status Indicator */}
        <div className="px-4 py-3 border-b border-border/50">
          <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-emerald-500/10">
            <Activity className="h-4 w-4 text-emerald-400 animate-pulse" />
            <span className="text-xs font-mono text-emerald-400">SYSTEM ONLINE</span>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 px-3 py-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-all duration-200',
                  isActive
                    ? 'bg-primary/15 text-primary border-l-2 border-primary'
                    : 'text-muted-foreground hover:bg-secondary hover:text-foreground'
                )
              }
              data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Footer */}
        <div className="border-t border-border/50 p-4">
          <div className="flex items-center gap-3 px-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary">
              <Shield className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-foreground truncate">Privacy Mode</p>
              <p className="text-[10px] text-muted-foreground">PII Detection Active</p>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;
